import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { I18nProvider } from "./lib/i18n";
import { AuthProvider, useAuth } from "./lib/auth";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Records from "./pages/Records";
import Employees from "./pages/Employees";
import Reports from "./pages/Reports";
import DeletedFiles from "./pages/DeletedFiles";
import Returns from "./pages/Returns";
import Warehouse from "./pages/Warehouse";
import { Layout } from "./components/Layout";

function Protected({ children, admin }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen grid place-items-center text-slate-500">...</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (admin && user.role !== "admin") return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Protected><Dashboard /></Protected>} />
            <Route path="/records" element={<Protected><Records /></Protected>} />
            <Route path="/reports" element={<Protected><Reports /></Protected>} />
            <Route path="/warehouse" element={<Protected><Warehouse /></Protected>} />
            <Route path="/returns" element={<Protected><Returns /></Protected>} />
            <Route path="/deleted-files" element={<Protected admin><DeletedFiles /></Protected>} />
            <Route path="/employees" element={<Protected admin><Employees /></Protected>} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
